import { Card, CardHeader, CardContent } from '../ui/Card'
import Skeleton from '../ui/Skeleton'

export const ReviewCardSleketon = () => {
  return (
    <Card className="h-40 flex border-0 border-b border-divider rounded-none">
      <div className="w-[60%] flex flex-col gap-2">
        <CardHeader>
          <Skeleton className="w-full h-5" />
          <Skeleton className="w-2/3 h-4" />
        </CardHeader>
        <CardContent className="mt-auto">
          <Skeleton className="w-full h-4" />
        </CardContent>
      </div>
      <div className="w-[40%]">
        <CardContent className="pt-4 h-full">
          <Skeleton className="w-full h-full" />
        </CardContent>
      </div>
    </Card>
  )
}

export default ReviewCardSleketon
